import { forwardRef } from "react";
import { FieldError } from "react-hook-form";
import {
  Field,
  FormFieldStatus,
  Hint,
  Input,
  Label,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import { getInputErrorStatus } from "src/utils/inputValidation";
import { FieldLevelError } from "src/common/api";

interface NameFieldProps {
  error?: FieldError;
  apiError?: FieldLevelError;
}

export const FirstNameField = forwardRef<HTMLInputElement, NameFieldProps>(
  ({ error, apiError, ...fields }, ref) => (
    <Field>
      <Label htmlFor="given_name">
        <Trans id="First name">First name</Trans>
      </Label>
      <Input
        id="given_name"
        name="given_name"
        status={getInputErrorStatus(!!error)}
        ref={ref}
        required
        {...fields}
      />
      {error && (
        <Hint status={FormFieldStatus.Danger}>
          <Trans id="first-name.field-required-warning">
            First name is required
          </Trans>
        </Hint>
      )}
      {apiError && (
        <Hint status={FormFieldStatus.Danger}>{apiError.message}</Hint>
      )}
    </Field>
  )
);

export const LastNameField = forwardRef<HTMLInputElement, NameFieldProps>(
  ({ error, apiError, ...field }, ref) => (
    <Field data-testid="family_name">
      <Label htmlFor="family_name">
        <Trans id="Last Name">Last name</Trans>
      </Label>
      <Input
        ref={ref}
        name="family_name"
        id="family_name"
        status={getInputErrorStatus(!!error)}
        required
        {...field}
      />
      {error && (
        <Hint status={FormFieldStatus.Danger}>
          <Trans id="last-name.field-required-warning">
            Last name is required
          </Trans>
        </Hint>
      )}
      {apiError && (
        <Hint status={FormFieldStatus.Danger}>{apiError.message}</Hint>
      )}
    </Field>
  )
);
